import Reveal from "./Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-crema">
      <div className="mx-auto max-w-4xl px-6 md:px-12">
        <Reveal delay={120}>
          <p className="font-sans text-xs tracking-[0.35em] uppercase text-terracota mb-5">
            Quién soy
          </p>
          <h2 className="font-serif font-light text-4xl md:text-5xl text-ciruela leading-tight tracking-tight">
            Cuidar de las mujeres es <span className="italic text-terracota">mi vocación</span>
          </h2>

          <div className="mt-8 space-y-5 font-body text-lg text-ciruela-dark/80 leading-relaxed max-w-2xl">
            <p>
              Llevo <strong className="font-semibold text-ciruela">más de 15 años</strong> acompañando a
              mujeres en algunos de los momentos más transformadores de su vida. Como{" "}
              <strong className="font-semibold text-ciruela">matrona</strong>, he estado presente en
              embarazos, partos, puerperios y en la llegada de la menopausia.
            </p>
            <p>
              Soy también <strong className="font-semibold text-ciruela">sexóloga</strong>, porque creo
              que la salud sexual y emocional es parte esencial del bienestar en cada etapa. Mi
              acompañamiento es cercano, profesional y libre de juicios: un espacio seguro para ti.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-12 max-w-lg">
            {[
              { n: "+15", l: "Años de experiencia" },
              { n: "4", l: "Etapas vitales" },
              { n: "100%", l: "Trato cercano" },
            ].map((s) => (
              <div key={s.l} className="text-center">
                <p className="font-serif text-4xl md:text-5xl text-terracota">{s.n}</p>
                <p className="font-sans text-[11px] md:text-xs tracking-wide uppercase text-ciruela-dark/60 mt-2">
                  {s.l}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
